import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getUserData } from '../utils/getUserInfo';
import NotAuthorized from './NotAuthorized';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const PUBLIC_PATHS = ['/login', '/register', '/logout-clear'];

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (PUBLIC_PATHS.some(p => location.pathname === p || location.pathname.startsWith('/error') || location.pathname.startsWith('/trust/'))) {
      setIsLoading(false);
      return;
    }

    getUserData().then((user) => {
      setIsAuthenticated(!!user);
      setIsLoading(false);
    }).catch(() => {
      setIsAuthenticated(false);
      setIsLoading(false);
    });
  }, [location.pathname]);

  if (isLoading) {
    return <div className="d-flex justify-content-center p-5"><span className="spinner-border text-primary" /></div>;
  }

  if (PUBLIC_PATHS.some(p => location.pathname === p) || location.pathname.startsWith('/error') || location.pathname.startsWith('/trust/')) {
    return <>{children}</>;
  }

  if (!isAuthenticated) {
    // Render the answer rather than navigating. Main's app-level gate normally catches an
    // anonymous visitor before this component ever mounts; this is the backstop for a
    // session that dies while the app is already open, and it must not redirect — that
    // race (two guards both bouncing) is what produced the flash to login.
    return <NotAuthorized />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
